import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const nl = ({ isActive }) => 'vt-nav__link' + (isActive ? ' active' : '');

  return (
    <header className={'vt-header' + (scrolled ? ' vt-header--scrolled' : '')}>
      <div className="vt-header__inner">
        <Link to="/" className="vt-header__brand">
          <img src="/logo.jpg" alt="Vedanskrix Tech" className="vt-header__logo" />
          <div className="vt-header__brand-text">
            <span className="vt-header__name">VEDANSKRIX</span>
            <span className="vt-header__sub">Tech Solutions</span>
          </div>
        </Link>

        <nav className={'vt-nav' + (menuOpen ? ' vt-nav--open' : '')} aria-label="Main navigation">
          <NavLink to="/" end className={nl}>Home</NavLink>
          <NavLink to="/services" className={nl}>Services</NavLink>
          <NavLink to="/portfolio" className={nl}>Portfolio</NavLink>
          <NavLink to="/contact" className={nl}>Contact</NavLink>
          <Link to="/contact" className="vt-header__cta">Get a Quote</Link>
        </nav>

        <button
          className={'vt-header__toggle' + (menuOpen ? ' open' : '')}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
